export default __webpack_public_path__ + "static/blobwax-e673c5e73e59a42cee4f682303eb7ed1.png";